
import dateFormat from 'vux/src/tools/date/format.js'
import CheckIcon from 'vux/src/components/check-icon/index.vue'
import Cell from 'vux/src/components/cell/index.vue'
import Checker from 'vux/src/components/checker/checker.vue'
import CheckerItem from 'vux/src/components/checker/checker-item.vue'
import Checklist from 'vux/src/components/checklist/index.vue'
import Toast from 'vux/src/components/toast/index.vue'
import Icon from 'vux/src/components/icon/index.vue'
import Grid from 'vux/src/components/grid/grid.vue'
import GridItem from 'vux/src/components/grid/grid-item.vue'
import GroupTitle from 'vux/src/components/group-title/index.vue'
import PopupPicker from 'vux/src/components/popup-picker/index.vue'
import Flexbox from 'vux/src/components/flexbox/flexbox.vue'
import FlexboxItem from 'vux/src/components/flexbox/flexbox-item.vue'
import Datetime from 'vux/src/components/datetime/index.vue'
import XTextarea from 'vux/src/components/x-textarea/index.vue'
import XInput from 'vux/src/components/x-input/index.vue'
import XHeader from 'vux/src/components/x-header/index.vue'
import Radio from 'vux/src/components/radio/index.vue'
import XButton from 'vux/src/components/x-button/index.vue'
import Group from 'vux/src/components/group/index.vue'
import PopupRadio from 'vux/src/components/popup-radio/index.vue'

export default {
data(){
return{
bb:false,
curDate:'',
beginDate:'',
endDate:''
}
},
methods:{
IdCodeValid(code){
let _this = this;
var city={11:"北京",12:"天津",13:"河北",14:"山西",15:"内蒙古",21:"辽宁",22:"吉林",23:"黑龙江 ",31:"上海",32:"江苏",33:"浙江",34:"安徽",35:"福建",36:"江西",37:"山东",41:"河南",42:"湖北 ",43:"湖南",44:"广东",45:"广西",46:"海南",50:"重庆",51:"四川",52:"贵州",53:"云南",54:"西藏 ",61:"陕西",62:"甘肃",63:"青海",64:"宁夏",65:"新疆",71:"台湾",81:"香港",82:"澳门",91:"国外 "};
var row = true;
if(!code || !/^\d{6}(18|19|20)?\d{2}(0[1-9]|1[012])(0[1-9]|[12]\d|3[01])\d{3}(\d|[X])$/.test(code)){
row=false;
_this.toastshow = true
_this.toastTxt = "证件号码有误";
}else if(!city[code.substr(0,2)]){
row=false;
_this.toastshow = true
_this.toastTxt = "证件号码有误,地址编码错误";
}else{

if(code.length == 18){
code = code.split('');
var factor = [ 7, 9, 10, 5, 8, 4, 2, 1, 6, 3, 7, 9, 10, 5, 8, 4, 2 ];

var parity = [ 1, 0, 'X', 9, 8, 7, 6, 5, 4, 3, 2 ];
var sum = 0;
var ai = 0;
var wi = 0;
for (var i = 0; i < 17; i++)
{
ai = code[i];
wi = factor[i];
sum += ai * wi;
}
if(parity[sum % 11] != code[17].toUpperCase()){
row=false;
_this.toastshow = true
_this.toastTxt = "证件号码有误,校验位错误";
}
}
}
return row;
},
},
components:{
dateFormat ,CheckIcon,Cell,Checker, CheckerItem,Checklist,Toast,Icon,Grid, GridItem, GroupTitle,PopupPicker,Flexbox, FlexboxItem,Datetime,XTextarea,XInput,XHeader,Radio ,XButton,Group, PopupRadio
},
mounted(){
this.curDate = new Date().toString();
this.beginDate = new Date(dateFormat(new Date(), 'YYYY-MM-DD')+' 07:00').toString();
this.endDate = new Date(dateFormat(new Date(), 'YYYY-MM-DD')+' 20:00').toString();
if(this.curDate >= this.beginDate && this.curDate <= this.endDate) {
this.bb = true;
}else{
this.bb = false;
}
/*
console.log(this.curDate,this.beginDate,this.endDate,this.curDate >= this.beginDate,this.curDate <= this.endDate,this.bb)*/
console.log(this.IdCodeValid('511621198911066484'))
if(this.$route.query.activityId){
console.log('有')
}else{
console.log('无')
}
}
}



// WEBPACK FOOTER //
// ./src/project/ceshi/tup.vue